module.exports = __webpack_public_path__ + "img/logo.dcb7ba3c.png";